import React from "react";
import { Helmet } from "react-helmet";

function HowToCleanBlinds() {
  const materials = [
    { type: "Real Wood", method: "Feather duster or dry microfibre cloth. Never use water.", icon: "🌳" },
    { type: "Faux Wood/PVC", method: "Damp cloth with mild detergent. Can be scrubbed lightly.", icon: "🌊" },
    { type: "Fabric Rollers", method: "Vacuum with brush attachment. Spot clean with a baby wipe.", icon: "🧵" },
  ];

  return (
    <div className="max-w-7xl mx-auto px-6 py-12 text-slate-900 leading-relaxed">
      <Helmet>
        <title>How to Clean Blinds | Care Guide for Every Material</title>
      </Helmet>

      <h1 className="text-5xl font-black mb-12 text-center">Maintain the <span className="text-emerald-600">Freshness.</span></h1>
      
      <div className="grid md:grid-cols-3 gap-8 mb-24">
        {materials.map((m) => (
          <div key={m.type} className="p-8 border border-slate-100 shadow-xl rounded-[2rem] text-center hover:scale-105 transition">
            <div className="text-4xl mb-4">{m.icon}</div>
            <h3 className="text-xl font-bold mb-3">{m.type}</h3>
            <p className="text-slate-600 text-sm">{m.method}</p>
          </div>
        ))}
      </div>

      <section className="max-w-4xl mx-auto bg-emerald-50 p-12 rounded-[3rem]">
        <h2 className="text-2xl font-bold mb-6">Deep Cleaning Venetian Slats</h2>
        <p className="mb-8">The "Slat Sandwich" method is the fastest way to clean Venetian blinds without taking them down.</p>
        
      </section>
    </div>
  );
}

export default HowToCleanBlinds;